import { createApp } from 'vue'
import Dictionary from './Dictionary'

const el = '.kb-component--dictionary'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DictionaryDOM) => {
            if (DictionaryDOM.getAttribute('data-v-app') !== null) return false
            const wordObjects = JSON.parse(DictionaryDOM.dataset.words).words

            const component = createApp(Dictionary, { wordObjects }).use(Store)
            component.mount(DictionaryDOM)
        })
    }
}
